export default {
    methods: {
        formatRupiah(angka) {
            if (angka === null) {
                angka = 0
            }
            if (angka !== undefined || angka !== null) {
                //return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(angka);

                let numb = 0;
                let textVal1 = new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR'}).format(angka);
                let textVal2 = new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR'}).format(numb);
                let diff = textVal2.replace("0,00","");
                let nom = angka<0 ? (textVal1.replace("-"+diff,"(Rp ").replace(" ","")+")") : textVal1;
                return nom.replace(",00","")
            }
        },

        formatCurrency(codeCur,angka){
            if (angka === null) {
                angka = 0
            }

            if (codeCur === null || codeCur === undefined || codeCur === ""){
                codeCur = 'IDR';
            }

            if (angka !== undefined || angka !== null) {
                let nom = new Intl.NumberFormat('id-ID', {style: 'currency', currency: codeCur}).format(angka);
                return nom.replace(",00","")
            }
        },

        formatCurrencyCode(codeCur,angka){
            if (angka === null) {
                angka = 0
            }
            if (codeCur === null || codeCur === undefined || codeCur === ""){
                codeCur = 'IDR';
            }

            if (angka !== undefined || angka !== null) {
                let tempangka = new Intl.NumberFormat('id-ID', {style: 'currency', currency: codeCur}).format(angka);
                let temprp = new Intl.NumberFormat('id-ID', {style: 'currency', currency: codeCur}).format(0);
                temprp = temprp.replace('0,00','');
                let nom = codeCur + " " + tempangka.replace(temprp,'');
                return nom.replace(",00","")
            }
            
        }

    },
}